import { render, staticRenderFns } from "./Accessory.vue?vue&type=template&id=3f9e95ce&"
import script from "./Accessory.vue?vue&type=script&lang=js&"
export * from "./Accessory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports